module.exports = __webpack_public_path__ + "img/diamonds-without.b25e440.jpg";